import React from 'react';
import { Star } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-charcoal text-white pt-12 pb-6 mt-16 border-t-4 border-brand-yellow" data-id="element-15">
      <div className="max-w-7xl mx-auto px-4" data-id="element-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-17">
          {/* Brand & Contact */}
          <div data-id="element-18">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.6gtools.com/uploaded/images/Redesign/6G%20Logo%20White%201.png" alt="6G Tools" className="h-10 object-contain mb-4" data-id="element-19" />
            <p className="text-brand-lightGold font-semibold" data-id="element-20">866.212.3385</p>
          </div>

          {/* Links */}
          <div data-id="element-21">
            <ul className="space-y-2 text-sm" data-id="element-22">
              <li data-id="element-23">
                <a href="https://www.6gtools.com/products/about-us.html" className="text-brand-yellow hover:text-brand-lightGold transition-colors" data-id="element-24">
                  ABOUT US
                </a>
              </li>
              <li data-id="element-25">
                <a href="https://www.6gtools.com/products/shipping-policy.html" className="text-brand-yellow hover:text-brand-lightGold transition-colors" data-id="element-26">
                  SHIPPING POLICY
                </a>
              </li>
              <li data-id="element-27">
                <a href="https://www.6gtools.com/products/return-policy.html" className="text-brand-yellow hover:text-brand-lightGold transition-colors" data-id="element-28">
                  RETURN POLICY
                </a>
              </li>
              <li data-id="element-29">
                <a href="https://www.6gtools.com/products/privacy%20policy.html" className="text-brand-yellow hover:text-brand-lightGold transition-colors" data-id="element-30">
                  PRIVACY POLICY
                </a>
              </li>
              <li data-id="element-31">
                <a href="https://www.6gtools.com/products/terms-and-conditions.html" className="text-brand-yellow hover:text-brand-lightGold transition-colors" data-id="element-32">
                  TERMS & CONDITIONS
                </a>
              </li>
            </ul>
          </div>

          {/* Reviews */}
          <div data-id="element-33">
            <h3 className="text-lg font-bold mb-4 text-brand-yellow" data-id="element-34">
              GOOGLE RATING
            </h3>
            <div className="bg-brand-darkGray p-4 rounded border border-gray-700" data-id="element-35">
              <div className="flex items-center gap-1 text-brand-yellow mb-2" data-id="element-36">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-current" data-id="element-37" />)}
              </div>
              <p className="text-sm font-semibold mb-2" data-id="element-38">
                6GTOOLS RATED 4.9 / 50 REVIEWS.
              </p>
              <a href="https://g.page/r/CWKGFpgXab1yEB0/review" target="_blank" rel="noopener noreferrer" className="text-brand-yellow hover:text-brand-lightGold text-sm font-bold uppercase tracking-wider transition-colors" data-id="element-39">
                | REVIEW US
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 pt-6 text-center text-xs text-gray-500" data-id="element-40">
          <p data-id="element-41">© COPYRIGHT 2025 ALL RIGHTS RESERVED</p>
        </div>
      </div>
    </footer>;
}